module.exports = "/_next/static/chunks/fonts/liv-up-logo-a6e9cf735989e0c78630c96156c5d825.svg";